module.exports = __webpack_public_path__ + "static/wine-and-song-c9133a65dafd7c7e433e25e7655f7455.png";